<template>
    <div class="content">
        <div class="close-btn">
          <button @click="$emit('closeModal')" class="btn btn-ligth p-1">
            <i class="fa fa-remove"></i>
        </button>
        </div>
        <p v-if="loading" class="loading-message">
          درحال بارگیری اطلاعات ...
        </p>
        <template v-else-if="report " >
          <ul  v-for="(item,index) in report" :key="index" class="list-report-user">
            <li >
              <b>
                شناسه کاربر :  
              </b>
              <span>
                {{ item.id?item.id:'' }}
              </span>
            </li>
            <li class="d-flex m-0 align-items-center">
              <b>
                نام کاربری :
              </b>
              <p class="d-flex m-0 align-items-center" style="gap: 4px;">
                <span>{{ item.full_name?item.full_name:(item.first_name?item.first_name:(item.last_name?item.last_name:''))  }}</span>
                <span v-if="(item.full_name||item.first_name||item.last_name) && item.mobile">
                  -
                </span>
                <span v-if="item.mobile">
                  
                  {{   item.mobile?item.mobile:"" }}
                </span>
              </p>
            </li>
            <li >
              <b>
                موجودی فعلی :
              </b>
              <span>
                {{item.wallet_balance | price }}
              </span>
            </li>
            <li >
              <b>
                دریافت :
              </b>
              <span>
                {{ item.total_deposit | price }}
              </span>
            </li>
            <li >
              <b>
                برداشت :
              </b>
              <span>
                {{  Math.abs(item.total_withdraw) | price  }}
              </span>
            </li>
            <li >
              <b>
                دفعات دریافت :
              </b>
              <span>
                {{  item.deposit_count | price }}
              </span>
            </li>
            <li >
              <b>
                دفعات برداشت :
              </b>
              <span>
                {{ item.withdraw_count | price  }}
              </span>
            </li>
            <a class="btn btn-outline-warning" target="_blank" :href="'/admin/customers/show/' + UserId">جزییات مشتری</a>
            
        </ul>
        </template>
        <p v-else class="text-center font-bold">
          برای این مشتری داده ای پیدا نشد
        </p>
    </div>
</template>
<script>
export default {
  name: "DetailWalletReport",
 
  
  data() {
    return {
      report:null,
      loading:true,
    }
  },
  props:{
    UserId:Number
  },
  created() {
    this.loadData()
  },
  methods: {
   
    
    
    async loadData() {
      try {
        this.loading = true
        const response = await this.$axios.get(`admin/reports/wallets?customer_id=${this.UserId}`);
        this.report = response.data.data.reports.data
       
       
      } catch (e) {
        this.$root.notify(e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>

.content{
  width: 800px;
  padding: 16px;
  background-color: #fff;
}
.list-report-user{
  display: grid;
  grid-template-columns: repeat(2,1fr);
  gap: 16px;
}
.loading-message{
  width: 100%;
  font-weight: 800;
  text-align: center;
}
.list-report-user li{
  font-size: 16px;
}
.close-btn{
  width: 100%;
  display: flex;
  justify-content: end;
}
.btn{
  font-size: 18px;
}
@media screen and (max-width:850px) {
  .content{
  width: 90%;
 
}

}
@media screen and (max-width:400px) {
 
.list-report-user{
  grid-template-columns: repeat(1,1fr);
 
}
}
</style>